<template>
  <div id="app">

    <ESTitle v-bind:currentTab="active">
      <div v-if="avatarGet" class="tabs-page">
        <button type="button" :class="{active: active === 'email'}" @click="active = 'email'">{{ $t('tabs.email') }}</button>
        <button type="button" :class="{active: active === 'avatar'}" @click="active = 'avatar'">{{ $t('tabs.avatar') }}</button>
      </div>
    </ESTitle>

    <div class="main-app overflow animated slideInUp">

      <transition name="panels">
        <section v-show="active === 'email'" class="panels">
          <div class="md-layout top-mentions">
            <h1 v-if="!avatarGet" class="h1">{{ $t('tabs.email') }}</h1>
            <div class="md-layout-item md-size-100">{{ $t('topMentions') }}</div>
          </div>
          <article class="panels__side panels__side--left">
            <div class="panels__side panels__side--inner panels__side--form">
              <ESForm />
            </div>
            <div class="panels__side panels__side--inner panels__side--instruction">
              <ESInstructions />
            </div>
          </article>
          <article class="panels__side panels__side--right panels__side--outlook">
            <div class="panels__side panels__side--inner">
              <ESOutlook />
            </div>
          </article>
        </section>
      </transition>

      <transition name="panels">
        <section v-show="active === 'avatar'" class="panels">
          <div class="md-layout top-mentions">
            <h1 v-if="!avatarGet" class="h1">{{ $t('tabs.avatar') }}</h1>
            <div class="md-layout-item md-size-100">{{ $t('avatar.topMentions') }}</div>
          </div>
          <FormAvatar />
        </section>
      </transition>


    </div>
    <div class="lang lang--fr" @click="changeLang()">
      <span>FR</span>
      <span>EN</span>
    </div>

    <ESError />

  </div>
</template>

<script>
import ESForm from './components/Form.vue';
import FormAvatar from './components/FormAvatar.vue';
import ESOutlook from './components/Outlook.vue';
import ESTitle from './components/Title.vue';
import ESInstructions from './components/Instructions.vue';
import ESError from './components/Error.vue';
import App from './main';
import EventBus from './eventBus';

import Utils from './utils';

export default {
  name: 'app',
  components: {
    ESTitle,
    ESForm,
    FormAvatar,
    ESOutlook,
    ESInstructions,
    ESError,
  },
  data: function () {
    return {
      headerGet: Utils.findGetParameter('header') && String(Utils.findGetParameter('header')) === 'false',
      avatarGet: Utils.findGetParameter('avatar') && String(Utils.findGetParameter('avatar')) === 'true',
      active: Utils.findGetParameter('active') && String(Utils.findGetParameter('active')) === 'avatar' ? 'avatar' : 'email',
    }
  },
  mounted: function() {
    const userLang = navigator.language || navigator.userLanguage;
    const locale = userLang === 'fr' ? 'fr' : 'en';
    if (locale === 'en') {
      const lang = document.querySelector('.lang');
      lang.classList.remove('lang--fr');
    }
    // PolyfillEdit IE closest
    if (window.Element && !Element.prototype.closest) {
      Element.prototype.closest =
      function closest(s) {
        const matches = (this.document || this.ownerDocument).querySelectorAll(s);
        let i;
        let el = this;
        do {
          i = matches.length;
          while (--i >= 0 && matches.item(i) !== el) { /* empty */ }
        } while ((i < 0) && (el = el.parentElement));
        return el;
      };
    }
  },
  methods: {
    goNext: function() {
      var panelLeft = document.querySelector('.panels__side--left');
      var panelRight = document.querySelector('.panels__side--right');
      panelRight.classList.toggle('panels__side--right-active');
      panelLeft.classList.toggle('panels__side--left-hidden');
    },
    changeLang: function(e) {
      const lang = document.querySelector('.lang');
      if (lang.classList.contains('lang--fr')) {
        App.locale = 'en';
      } else {
        App.locale = 'fr';
      }
      lang.classList.toggle('lang--fr');
      EventBus.$emit('changeLanguage', App.locale);
      Utils.generateTag('navigation-switch-lang', 'click', App.locale);
    },
  }
}
</script>

<style lang="scss">
@import './scss/common.scss';
</style>



// WEBPACK FOOTER //
// src/App.vue